var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classCss,attrs:{"id":_vm.id,"href":_vm.localePath(_vm.href, _vm.i18n.locale)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }